module.exports = __webpack_public_path__ + "static/media/gojek.2a706564.png";